import { render } from "./SystemLayout.vue?vue&type=template&id=6da34190&scoped=true"
import script from "@/assets/Js/systemset/systemlayout.js?vue&type=script&lang=js&external"
export * from "@/assets/Js/systemset/systemlayout.js?vue&type=script&lang=js&external"

import "@/assets/Css/app-theme.css?vue&type=style&index=0&id=6da34190&scoped=true&lang=css&external"
import "@/assets/Css/systemset/systemlayout.css?vue&type=style&index=1&id=6da34190&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da34190"]])

export default __exports__